import Drag from './dragDrop';
import Filter from './filter';
import Flash from './flash';
import {Table} from './dateTime';
import SprintReports from './sprintReports';
import ContractSummary from './contractSummary';
import LocalStateStore from './localStateStore';
import Quill from './quill';
import LineChart from './lineChart';
import RangeSlider from './rangeSlider';
import ScrollTo from './scrollTo';
import CopyToClipboard from './copyToClipboard';

const Hooks = {
  Drag,
  Table,
  Filter,
  Flash,
  SprintReports,
  ContractSummary,
  LocalStateStore,
  Quill,
  LineChart,
  RangeSlider,
  ScrollTo,
  CopyToClipboard,
};

export default Hooks;
